var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 23,
    viewBox: "0 0 98 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18722",
    "data-name": "Group 18722",
    transform: "translate(-487 -1560)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25857",
    "data-name": "Path 25857",
    d: "M22.514,92.95C14.1,88.876,2.883,66.885.841,51.212-1.369,34.247.485,24.531,9.864,4.618c-1.33.295-2.363.573-3.413.744a19.99,19.99,0,0,1-3.456.351C2.636,5.709,2.051,5.09,2,4.7a1.472,1.472,0,0,1,.741-1.2C5.931,2.315,9.147,1.2,12.375.128A1.514,1.514,0,0,1,14.541,1.34c1.072,4.327,2.2,8.641,3.178,12.989a15.523,15.523,0,0,1-.082,3.549c-2.826-1.084-2.5-3.476-3.262-5.18-.8-1.8-1.283-3.744-2.043-6.045A52.69,52.69,0,0,0,4.8,23.642c-5.417,21.664-.953,41.546,11.15,59.963,1.576,2.4,3.429,4.612,5.124,6.934.458.628.806,1.336,1.444,2.411",
    transform: "translate(582.475 1560.485) rotate(90)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17320",
    "data-name": "Rectangle 17320",
    width: 98,
    height: 23,
    transform: "translate(487 1560)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepArrow);
export default __webpack_public_path__ + "static/media/step-arrow.1e2208221928e0baded2bf8d900d225d.svg";
export { ForwardRef as ReactComponent };